import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

const DisplayWrapperImage = ({ aspectRatio, children, embed, rounded }) => (
  <>
    <WrapperImage
      as="img"
      alt=""
      src={embed.thumbnail_url}
      $aspectRatio={aspectRatio}
      $embed={embed}
      $type={embed.type}
      $rounded={rounded}
    />
    {children}
  </>
);

DisplayWrapperImage.propTypes = {
  embed: PropTypes.shape({
    thumbnail_url: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  rounded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node,
};

DisplayWrapperImage.defaultProps = {
  isEmbedVideoOnHtml: true,
  rounded: true,
};

export default DisplayWrapperImage;

const WrapperImage = styled(Box).attrs(({ $embed }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  font: 'h2-regular',
  textAlign: 'center',
  opacity: $embed.thumbnail_url ? 1 : 0,
}))`
  ${({ $aspectRatio }) =>
    $aspectRatio
      ? css`
          aspect-ratio: ${$aspectRatio};
        `
      : ''};
  ${focusOutline}
  background-repeat: no-repeat;
  background-position: ${({ $type }) => ($type === 'pdf' ? 'top' : 'center')};
  background-size: cover;
  border-radius: ${({ $rounded }) =>
    $rounded === true ? '4px 4px 0px 0px' : $rounded || '0px'};
  object-fit: cover;
`;
